import { SettingsService } from '@/services/settings'
import { type GtmSupport, useGtm as useGtmPlugin } from '@gtm-support/vue-gtm'
import { useCookies } from '@vueuse/integrations/useCookies.mjs'

let PIXEL_ID_FETCHED = false

export async function useGtm(): Promise<GtmSupport | undefined> {
  if (PIXEL_ID_FETCHED) {
    return useGtmPlugin()
  }

  const sitePixelId = await SettingsService.getSitePixelId()

  if (sitePixelId) {
    useCookies().set('meta_pixel_id', sitePixelId, {
      path: '/',
      sameSite: 'lax',
    })
  }

  PIXEL_ID_FETCHED = true

  return useGtmPlugin()
}

export function initializeGA(): void {
  const siteTagId = SettingsService.getSiteTagId()
  const siteMeasurementId = SettingsService.getSiteMeasurementId()

  if (siteTagId && siteMeasurementId) {
    useCookies().set('ga_tag_id', siteTagId, {
      path: '/',
      sameSite: 'lax',
    })
    useCookies().set('ga_measurement_id', siteMeasurementId, {
      path: '/',
      sameSite: 'lax',
    })
  }
}
